import EventStats from '@/screens/EventStats';

export default function PrivateTabsOrganizationScheduleScheduleBEventIdStatsRoute() {
  return <EventStats />;
}
